import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LotterySign {
  id: number;
  name: string;
  poem: string;
  point: number;
  weight: number;
  sorting: number;
  enabled: boolean;
}

export interface LotterySignInfo {
  lottery_signs: Array<LotterySign>;
  lottery_sign: LotterySign;
}

@Module
export default class LotterySignModule
  extends VuexModule
  implements LotterySignInfo
{
  lottery_signs = [] as Array<LotterySign>;
  lottery_sign = {} as LotterySign;

  get currentLotterySign(): LotterySign {
    return this.lottery_sign;
  }

  get currentLotterySigns(): Array<LotterySign> {
    return this.lottery_signs;
  }

  @Mutation
  [Mutations.SET_LOTTERY_SIGN](lottery_sign) {
    this.lottery_sign = lottery_sign;
  }

  @Mutation
  [Mutations.SET_LOTTERY_SIGNS](lottery_signs) {
    this.lottery_signs = lottery_signs;
  }

  @Action
  [Actions.GET_LOTTERY_SIGNS](params) {
    ApiService.setHeader();

    let queryString = "?";

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/lottery_signs", queryString)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_LOTTERY_SIGNS,
            data["lottery_signs"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.GET_LOTTERY_SIGN](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/lottery_signs/${id}`)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_LOTTERY_SIGN,
            data["lottery_sign"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.CREATE_LOTTERY_SIGN](credentials) {
    ApiService.setHeader();

    const params = {
      lottery_sign: {
        ...credentials,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.post(`admin/lottery_signs`, params)
        .then(({ data }) => {
          if (data["success"] === false) {
            reject(data["error_msg"]);
            return;
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.UPDATE_LOTTERY_SIGN](credentials) {
    ApiService.setHeader();

    const params = {
      lottery_sign: {
        ...credentials.values,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.put(`admin/lottery_signs/${credentials.id}`, params)
        .then(({ data }) => {
          if (data["success"] === false) {
            reject(data["error_msg"]);
            return;
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.DELETE_LOTTERY_SIGN](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.delete(`admin/lottery_signs/${id}`)
        .then(({ data }) => {
          if (data["success"] === false) {
            reject(data["error_msg"]);
            return;
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }
}
